var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      ref: "addToWishList",
      staticClass:
        "btn btn-sm add-to-wish-list d-flex justify-content-center align-items-center",
      class: _vm.hideText ? "" : "w-100",
      attrs: { role: "button", title: _vm.tooltipText, tabindex: "0" },
      on: {
        click: function ($event) {
          $event.preventDefault()
          return _vm.switchState()
        },
      },
    },
    [
      !_vm.hideText
        ? _c("span", { staticClass: "mr-2 mr-md-3 text-nowrap" }, [
            _vm._v(
              _vm._s(_vm.$translate("Ceres::Template.singleItemWishList"))
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("icon", {
        staticClass: "default-float",
        class: { "text-appearance text-danger": _vm.isVariationInWishList },
        attrs: {
          icon: _vm.isVariationInWishList
            ? "heart"
            : _vm.hideText
            ? "heart fal"
            : "heart far",
          loading: _vm.isLoading,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }